import React, { useState } from "react"
import { Link } from "gatsby"
import { Menu } from "antd"
import { ChevronDown, Search } from "../Icon"

import "./MainNav.less"
import useMenus from "../../hooks/useMenus"

const { SubMenu } = Menu

function MenuDesktop({ setShowSearch }) {
  const menus = useMenus()
  const [state, setState] = useState({
    current: "",
    visible: false,
  })

  const handleClick = e => {
    setState(p => ({ ...p, current: e.key }))
  }

  const { current } = state

  return (
    <>
      <Menu
        onClick={handleClick}
        selectedKeys={[current]}
        mode="horizontal"
        className="header-menu"
      >
        {menus.map(function (item) {
          const { submenu, title, key, link, page_name} = item
          if (submenu !== undefined) {
            return (
              <SubMenu key={key} title={title} icon={<ChevronDown />}>
                {submenu.map(function (child) {
                  if (child.submenu !== undefined && child.submenu.length > 0) {
                    return (
                      <SubMenu key={child.key} title={child.title}>
                        {child.submenu.map(function (subchild) {
                          return (
                            <Menu.Item key={subchild.key} data-page={subchild.page_name}>
                              <Link to={subchild.link}>{subchild.title}</Link>
                            </Menu.Item>
                          )
                        })}
                      </SubMenu>
                    )
                  } else if (child.submenu === undefined) {
                    return (
                      <Menu.Item key={child.key} data-page={child.page_name}>
                        <Link to={child.link}>{child.title}</Link>
                      </Menu.Item>
                    )
                  }
                })}
              </SubMenu>
            )
          } else {
            return (
              <Menu.Item key={key} data-page={page_name}>
                <Link to={link}>{title}</Link>
              </Menu.Item>
            )
          }
        })}
        <Menu.Item key="search" onClick={() => setShowSearch(true)}>
          <Search />
        </Menu.Item>
      </Menu>
    </>
  )
}

export default MenuDesktop
